export default "__VITE_ASSET__e45ebf89__"